import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../../shared/store';
import { User } from '../../../../shared/models/UserModels';

export interface UsersLayout {
  selectedRows: User[];
}

const initialState: UsersLayout = {
  selectedRows: [],
};

export const adminUsersLayoutSlice = createSlice({
  name: 'usersLayout',
  initialState,
  reducers: {
    addUsers: (state, { payload }: { payload: User[] }) => ({
      ...state,
      selectedRows: [...state.selectedRows, ...payload],
    }),
    removeUsers: (state, { payload }: { payload: string[] }) => ({
      ...state,
      selectedRows: [
        ...state.selectedRows.filter((e) => !payload.includes(e.id)),
      ],
    }),
  },
  extraReducers: () => {},
});

export const { addUsers, removeUsers } = adminUsersLayoutSlice.actions;
export const adminUsersLayoutSelector = (state: RootState) =>
  state.adminUsersLayout;
